import { render, staticRenderFns } from "./apply12.vue?vue&type=template&id=3d22b9d5&scoped=true&"
import script from "./apply12.vue?vue&type=script&lang=js&"
export * from "./apply12.vue?vue&type=script&lang=js&"
import style0 from "./apply12.vue?vue&type=style&index=0&id=3d22b9d5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d22b9d5",
  null
  
)

export default component.exports